<template>
  <div>
    <nav-bar />
    <section id="intro">
      <div class="profile-img-wrap">
        <img class="profile-img" src="crop-me.jpg" alt="profile-img" />
      </div>
      <p class="hello-txt">Hello 👋🏽</p>
      <div class="wrapper dynamic-txt-box">
        <div class="static-txt">I'm</div>
        <ul class="dynamic-txts">
          <li><span>Madhavi Imashi Uyanahewa</span></li>
          <li><span>a Content Writer | Blogger</span></li>
          <li><span>a Software Developer</span></li>
          <li><span>a Graduate | BSc (hons) in SE</span></li>
        </ul>
      </div>
    </section>

    <section id="quote">
      <div class="panels">
        <div id="panel1" :class="componentClasses1" @click="openPanel1">
          <p>I</p>
          <p>Never</p>
          <p>Quit.</p>
        </div>

        <div id="panel2" :class="componentClasses2" @click="openPanel2">
          <p>Let me</p>
          <p>Be</p>
          <p>clear.</p>
        </div>

        <div id="panel3" :class="componentClasses3" @click="openPanel3">
          <p></p>
          <p id="panel3Quote">Quick</p>
          <p></p>
        </div>

        <div id="panel4" :class="componentClasses4" @click="openPanel4">
          <p>I Thrive</p>
          <p>To</p>
          <p>Success.</p>
        </div>

        <div id="panel5" :class="componentClasses5" @click="openPanel5">
          <p>Better</p>
          <p>Judge</p>
          <p>Me Later</p>
        </div>
      </div>
    </section>

    <section id="learnings">
      <div class="technology-section-wrap">
        <b-row>
          <b-col sm="7" class="tech-description">
            <div>
              <div class="tech-desc-title">
                TECHNOLOGIES THAT I'M FAMILIAR WITH..
              </div>
              <p>
                I'm a passionate and self-driven software developer dedicated to
                crafting immersive digital experiences. With a strong software
                engineering background, I'm committed to transforming complex
                challenges into elegant solutions
              </p>
              <br />
              <p>
                My proficiency includes object-oriented programming and hands-on experience in web technologies like
                HTML, CSS, JavaScript, React, Vue, Node.js, and SQL/NoSQL databases.
              </p>
              <br />
              <p>
                In the mobile space, I specialize in the <b>React Native</b> ecosystem including <b>Expo</b>,
                <b>Redux</b>, <b>TanStack Query</b>, <b>Tailwind CSS</b>, and native tools like <b>Xcode</b> and
                <b>Android Studio</b>.
              </p>
              <br />
              <div class="contact-list">
                <ul>
                  <li><span class="contact-me-txt">CONNECT:</span></li>
                  <li>
                    <a
                      href="https://www.linkedin.com/in/madhaviuyanahewa/"
                      target="_blank"
                      ><i class="fab fa-linkedin"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      href="https://www.facebook.com/imashi.uh/"
                      target=" _blank"
                      ><i class="fab fa-facebook"></i
                    ></a>
                  </li>
                  <li>
                    <a href="https://github.com/MadhaviImashi" target=" _blank"
                      ><i class="fab fa-github"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      href="https://medium.com/@madhaviuyanahewa"
                      target=" _blank"
                      ><i class="fab fa-medium"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      href="https://www.behance.net/madhaviuyanahe"
                      target=" _blank"
                      ><i class="fab fa-behance"></i
                    ></a>
                  </li>
                </ul>
              </div>
              <br />
              <b-button
                class="blinking-button"
                variant="outline-secondary"
                @click="showCV"
                >VIEW MY RESUME</b-button
              >
            </div>
          </b-col>

          <b-col sm="5" class="tech-icons-card-wrap">
            <b-card class="tech-icons-card border-0">
              <b-row class="tech-icons-row">
                <b-col>
                  <a
                    href="https://developer.mozilla.org/en-US/docs/Web/JavaScript"
                    target=" _blank"
                    title="JavaScript"
                    ><img
                      src="https://github.com/get-icon/geticon/raw/master/icons/javascript.svg"
                      alt="JavaScript"
                      width="40px"
                      height="40px"
                  /></a>
                </b-col>
                <b-col>
                  <a
                    href="https://tc39.es/ecma262/"
                    target=" _blank"
                    title="ECMAScript 6"
                    ><img
                      src="https://github.com/get-icon/geticon/raw/master/icons/es6.svg"
                      alt="ECMAScript 6"
                      width="40px"
                      height="40px"
                  /></a>
                </b-col>
                <b-col>
                  <a href="https://vuejs.org/" target=" _blank" title="Vue.js"
                    ><img
                      src="https://github.com/get-icon/geticon/raw/master/icons/vue.svg"
                      alt="Vue.js"
                      width="40px"
                      height="40px"
                  /></a>
                </b-col>
                <b-col>
                  <a href="https://sass-lang.com/" target=" _blank" title="Sass"
                    ><img
                      src="https://github.com/get-icon/geticon/raw/master/icons/sass.svg"
                      alt="Sass"
                      width="40px"
                      height="40px"
                  /></a>
                </b-col>
                <b-col>
                  <a href="https://reactjs.org/" target=" _blank" title="React"
                    ><img
                      src="https://github.com/get-icon/geticon/raw/master/icons/react.svg"
                      alt="React"
                      width="40px"
                      height="40px"
                  /></a>
                </b-col>
                <b-col>
                  <a
                    href="https://reactnative.dev/"
                    target=" _blank"
                    title="React Native (iOS)"
                    ><img
                      src="https://reactnative.dev/img/header_logo.svg"
                      alt="React Native"
                      width="40px"
                      height="40px"
                  /></a>
                </b-col>
              </b-row>
              <b-row class="tech-icons-row">
                <b-col>
                  <a
                    href="https://ant.design/"
                    target=" _blank"
                    title="Ant Design"
                    ><img
                      src="https://github.com/get-icon/geticon/raw/master/icons/ant-design.svg"
                      alt="Ant Design"
                      width="40px"
                      height="40px"
                  /></a>
                </b-col>
                <b-col>
                  <a
                    href="https://getbootstrap.com/"
                    target=" _blank"
                    title="Bootstrap"
                    ><img
                      src="https://github.com/get-icon/geticon/raw/master/icons/bootstrap.svg"
                      alt="Bootstrap"
                      width="40px"
                      height="40px"
                  /></a>
                </b-col>
                <b-col>
                  <a
                    href="https://www.w3.org/TR/html5/"
                    target=" _blank"
                    title="HTML5"
                    ><img
                      src="https://github.com/get-icon/geticon/raw/master/icons/html-5.svg"
                      alt="HTML5"
                      width="40px"
                      height="40px"
                  /></a>
                </b-col>
                <b-col>
                  <a href="https://nodejs.org/" target=" _blank" title="Node.js"
                    ><img
                      src="https://github.com/get-icon/geticon/raw/master/icons/nodejs-icon.svg"
                      alt="Node.js"
                      width="40px"
                      height="40px"
                  /></a>
                </b-col>
                <b-col>
                  <a href="https://expressjs.com/" target=" _blank" title="C"
                    ><img
                      src="https://github.com/get-icon/geticon/raw/master/icons/c.svg"
                      alt="C"
                      width="40px"
                      height="40px"
                  /></a>
                </b-col>
              </b-row>
              <b-row class="tech-icons-row">
                <b-col>
                  <a
                    href="https://laravel.com/"
                    target=" _blank"
                    title="Laravel"
                    ><img
                      src="https://github.com/get-icon/geticon/raw/master/icons/laravel.svg"
                      alt="Laravel"
                      width="40px"
                      height="40px"
                  /></a>
                </b-col>
                <b-col>
                  <a href="https://www.java.com/" target=" _blank" title="Java"
                    ><img
                      src="https://github.com/get-icon/geticon/raw/master/icons/java.svg"
                      alt="Java"
                      width="40px"
                      height="40px"
                  /></a>
                </b-col>
                <b-col>
                  <a
                    href="https://www.python.org/"
                    target=" _blank"
                    title="Python"
                    ><img
                      src="https://github.com/get-icon/geticon/raw/master/icons/python.svg"
                      alt="Python"
                      width="40px"
                      height="40px"
                  /></a>
                </b-col>
                <b-col>
                  <a href="https://eslint.org/" target=" _blank" title="ESLint"
                    ><img
                      src="https://github.com/get-icon/geticon/raw/master/icons/eslint.svg"
                      alt="ESLint"
                      width="21px"
                      height="21px"
                  /></a>
                </b-col>
                <b-col>
                  <a
                    href="https://prettier.io/"
                    target=" _blank"
                    title="Prettier"
                    ><img
                      src="https://github.com/get-icon/geticon/raw/master/icons/prettier.svg"
                      alt="Prettier"
                      width="21px"
                      height="21px"
                  /></a>
                </b-col>
              </b-row>
              <b-row class="tech-icons-row">
                <b-col>
                  <b-tooltip
                    target="npm-link"
                    title="npm"
                    triggers="hover"
                  ></b-tooltip>
                  <a href="https://www.npmjs.com/" target=" _blank" title="npm"
                    ><img
                      src="https://github.com/get-icon/geticon/raw/master/icons/npm.svg"
                      alt="npm"
                      width="40px"
                      height="40px"
                  /></a>
                </b-col>
                <b-col>
                  <a
                    href="https://material-ui.com/"
                    target=" _blank"
                    title="Material UI"
                    ><img
                      src="https://github.com/get-icon/geticon/raw/master/icons/material-ui.svg"
                      alt="Material UI"
                      width="40px"
                      height="40px"
                  /></a>
                </b-col>
                <b-col>
                  <a
                    href="https://flutter.dev/"
                    target=" _blank"
                    title="Flutter"
                    ><img
                      src="https://github.com/get-icon/geticon/raw/master/icons/flutter.svg"
                      alt="Flutter"
                      width="40px"
                      height="40px"
                  /></a>
                </b-col>
                <b-col>
                  <a
                    href="https://www.postman.com/"
                    target=" _blank"
                    title="Postman"
                    ><img
                      src="https://github.com/get-icon/geticon/raw/master/icons/postman.svg"
                      alt="Postman"
                      width="40px"
                      height="40px"
                  /></a>
                </b-col>
              </b-row>
              <b-row class="tech-icons-row">
                <b-col>
                  <a href="https://www.typescriptlang.org/" target=" _blank" title="TypeScript">
                    <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg" alt="TypeScript" width="40px" height="40px" />
                  </a>
                </b-col>
                <b-col>
                  <a href="https://tailwindcss.com/" target=" _blank" title="Tailwind CSS">
                    <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/tailwindcss/tailwindcss-original.svg" alt="Tailwind CSS" width="40px" height="40px" />
                  </a>
                </b-col>
                <b-col>
                  <a href="https://redux.js.org/" target=" _blank" title="Redux">
                    <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/redux/redux-original.svg" alt="Redux" width="40px" height="40px" />
                  </a>
                </b-col>
                <b-col>
                  <a href="https://expo.dev/" target=" _blank" title="Expo">
                    <img src="https://www.vectorlogo.zone/logos/expoio/expoio-icon.svg" alt="Expo" width="40px" height="40px" />
                  </a>
                </b-col>
                <b-col>
                  <a href="https://jestjs.io/" target=" _blank" title="Jest">
                    <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/jest/jest-plain.svg" alt="Jest" width="40px" height="40px" />
                  </a>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </section>

    <!-- ======= Portfolio Section ======= -->
    <section
      id="work"
      class="work-section work-section-container portfolio-mf sect-pt4 route"
    >
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <div class="title-box text-center">
              <h3 class="title-a">PROJECTS COMPLETED</h3>
              <div class="line-mf"></div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <div class="work-box">
              <a
                href="12.png"
                data-gallery="portfolioGallery"
                class="portfolio-lightbox"
              >
                <div class="work-img">
                  <img src="12.png" alt="" class="img-fluid" />
                </div>
              </a>
              <div class="work-content">
                <div class="row">
                  <div class="col-sm-12">
                    <div class="tech-box-container">
                      <span class="tech-box">ReactNative</span>
                      <span class="tech-box">Expo</span>
                      <span class="tech-box">Node</span>
                      <span class="tech-box">MongoDB</span>
                      <span class="tech-box">CSS</span>
                    </div>
                    <div class="w-more">
                      <span class="w-ctegory"
                        ><a
                          style="text-decoration: none"
                          href="https://www.behance.net/gallery/179924583/Space-exploration-app"
                          target="blank"
                          >Mobile Design</a
                        ></span
                      >
                      / <span class="w-date">Tech Thriathlon</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="work-box">
              <a
                href="5.png"
                data-gallery="portfolioGallery"
                class="portfolio-lightbox"
              >
                <div class="work-img">
                  <img src="5.png" alt="" class="img-fluid" />
                </div>
              </a>
              <div class="work-content">
                <div class="row">
                  <div class="col-sm-10">
                    <!-- <h2 class="w-title">Lorem impsum dolor</h2> -->
                    <div class="tech-box-container">
                      <span class="tech-box">ReactNative</span>
                      <span class="tech-box">Expo</span>
                      <span class="tech-box">Python</span>
                      <span class="tech-box">Firebase</span>
                      <span class="tech-box">AWS</span>
                    </div>
                    <div class="w-more">
                      <span class="w-ctegory"
                        ><a
                          style="text-decoration: none"
                          href="https://www.behance.net/gallery/176137191/Expense-Prediction-based-on-users-calendar-events"
                          target="blank"
                          >Mobile Design</a
                        ></span
                      >
                      / <span class="w-date">4th Year Research</span>
                    </div>
                  </div>
                  <div class="col-sm-2">
                    <div class="w-like">
                      <a
                        href="https://madhaviimashi.github.io/wonga.github.io/"
                        target="blank"
                      >
                        <span style="font-size: 11px" class="bi bi-plus-circle"
                          >website</span
                        ></a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="work-box">
              <a
                href="3.png"
                data-gallery="portfolioGallery"
                class="portfolio-lightbox"
              >
                <div class="work-img">
                  <img src="3.png" alt="" class="img-fluid" />
                </div>
              </a>
              <div class="work-content">
                <div class="row">
                  <div class="col-sm-12">
                    <!-- <h2 class="w-title">Loreda Cuno Nere</h2> -->
                    <div class="tech-box-container">
                      <span class="tech-box">React</span>
                      <span class="tech-box">Express</span>
                      <span class="tech-box">Node.js</span>
                      <span class="tech-box">MongoDB</span>
                    </div>
                    <div class="w-more">
                      <span class="w-ctegory"
                        ><a
                          style="text-decoration: none"
                          href="https://www.behance.net/gallery/143060395/Login-SignUp-forms-for-Research-Project-Management-Tool"
                          target="blank"
                          >Web Design</a
                        ></span
                      >
                      / <span class="w-date">Year 3 Semester 2</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="work-box">
              <a
                href="4.png"
                data-gallery="portfolioGallery"
                class="portfolio-lightbox"
              >
                <div class="work-img">
                  <img src="4.png" alt="" class="img-fluid" />
                </div>
              </a>
              <div class="work-content">
                <div class="row">
                  <div class="col-sm-12">
                    <!-- <h2 class="w-title">Mavrito Lana Dere</h2> -->
                    <div class="tech-box-container">
                      <span class="tech-box">React</span>
                      <span class="tech-box">Koa.js</span>
                      <span class="tech-box">Node.js</span>
                      <span class="tech-box">MongoDB</span>
                    </div>
                    <div class="w-more">
                      <span class="w-ctegory"
                        ><a
                          style="text-decoration: none"
                          href="https://www.behance.net/gallery/145371465/Online-movie-reservation-system"
                          target="blank"
                          >Web Design</a
                        ></span
                      >
                      / <span class="w-date">Year 3 Semester 2</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="work-box">
              <a
                href="9.png"
                data-gallery="portfolioGallery"
                class="portfolio-lightbox"
              >
                <div class="work-img">
                  <img src="9.png" alt="" class="img-fluid" />
                </div>
              </a>
              <div class="work-content">
                <div class="row">
                  <div class="col-sm-12">
                    <!-- <h2 class="w-title">Bindo Laro Cado</h2> -->
                    <div class="tech-box-container">
                      <span class="tech-box">Java</span>
                      <span class="tech-box">Volley</span>
                      <span class="tech-box">Express</span>
                      <span class="tech-box">Node.js</span>
                      <span class="tech-box">MongoDB</span>
                    </div>
                    <div class="w-more">
                      <span class="w-ctegory"
                        ><a
                          style="text-decoration: none"
                          href="https://www.behance.net/gallery/156257653/SL-Fuel-App"
                          target="blank"
                          >Mobile Design</a
                        ></span
                      >
                      / <span class="w-date">Year 4 Semester 1</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="work-box">
              <a
                href="2.png"
                data-gallery="portfolioGallery"
                class="portfolio-lightbox"
              >
                <div class="work-img">
                  <img src="2.png" alt="" class="img-fluid" />
                </div>
              </a>
              <div class="work-content">
                <div class="row">
                  <div class="col-sm-12">
                    <!-- <h2 class="w-title">Studio Lena Mado</h2> -->
                    <div class="tech-box-container">
                      <span class="tech-box">HTML5</span>
                      <span class="tech-box">CSS</span>
                      <span class="tech-box">Javascript</span>
                      <span class="tech-box">Bootstrap</span>
                      <span class="tech-box">PHP</span>
                    </div>
                    <div class="w-more">
                      <span class="w-ctegory"
                        ><a
                          style="text-decoration: none"
                          href="https://www.behance.net/gallery/125410597/Online-Meal-Cart"
                          target="blank"
                          >Web Design</a
                        ></span
                      >
                      / <span class="w-date">Year 2 Semester 1</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="work-box">
              <a
                href="10.png"
                data-gallery="portfolioGallery"
                class="portfolio-lightbox"
              >
                <div class="work-img">
                  <img src="10.png" alt="" class="img-fluid" />
                </div>
              </a>
              <div class="work-content">
                <div class="row">
                  <div class="col-sm-12">
                    <!-- <h2 class="w-title">Studio Big Bang</h2> -->
                    <div class="tech-box-container">
                      <span class="tech-box">PHP</span>
                      <span class="tech-box">Laravel</span>
                      <span class="tech-box">phpMyAdmim</span>
                      <span class="tech-box">MySQL</span>
                    </div>
                    <div class="w-more">
                      <span class="w-ctegory"
                        ><a
                          style="text-decoration: none"
                          href="https://www.behance.net/gallery/125410315/Online-Hotel-Management-System"
                          target="blank"
                          >Web Design</a
                        ></span
                      >
                      / <span class="w-date">Year 2 Semester 2</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="work-box">
              <a
                href="1.png"
                data-gallery="portfolioGallery"
                class="portfolio-lightbox"
              >
                <div class="work-img">
                  <img src="1.png" alt="" class="img-fluid" />
                </div>
              </a>
              <div class="work-content">
                <div class="row">
                  <div class="col-sm-12">
                    <!-- <h2 class="w-title">Studio Big Bang</h2> -->
                    <div class="tech-box-container">
                      <span class="tech-box">Java</span>
                      <span class="tech-box">JSP</span>
                      <span class="tech-box">Servlet</span>
                      <span class="tech-box">CSS</span>
                      <span class="tech-box">MySQL</span>
                    </div>
                    <div class="w-more">
                      <span class="w-ctegory"
                        ><a
                          style="text-decoration: none"
                          href="https://www.behance.net/gallery/125410895/LoginRegistration-of-an-Event-management-system"
                          target="blank"
                          >Web Design</a
                        ></span
                      >
                      / <span class="w-date">Year 2 Semester 1</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="work-box">
              <a
                href="8.png"
                data-gallery="portfolioGallery"
                class="portfolio-lightbox"
              >
                <div class="work-img">
                  <img src="8.png" alt="" class="img-fluid" />
                </div>
              </a>
              <div class="work-content">
                <div class="row">
                  <div class="col-sm-12">
                    <!-- <h2 class="w-title">Studio Big Bang</h2> -->
                    <div class="tech-box-container">
                      <span class="tech-box">Java</span>
                      <span class="tech-box">SQLite</span>
                    </div>
                    <div class="w-more">
                      <span class="w-ctegory"
                        ><a
                          style="text-decoration: none"
                          href="https://www.behance.net/gallery/125409683/BestPlan_For-a-healthy-simple-productive-lifestyle"
                          target="blank"
                          >Web Design</a
                        ></span
                      >
                      / <span class="w-date">Year 2 Semester 2</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="work-box">
              <a
                href="7.png"
                data-gallery="portfolioGallery"
                class="portfolio-lightbox"
              >
                <div class="work-img">
                  <img src="7.png" alt="" class="img-fluid" />
                </div>
              </a>
              <div class="work-content">
                <div class="row">
                  <div class="col-sm-12">
                    <!-- <h2 class="w-title">Studio Big Bang</h2> -->
                    <div class="tech-box-container">
                      <span class="tech-box">Vue.js</span>
                      <span class="tech-box">Laravel</span>
                      <span class="tech-box">phpMyAdmin</span>
                      <span class="tech-box">MySQL</span>
                    </div>
                    <div class="w-more">
                      <span class="w-ctegory"
                        ><a
                          style="text-decoration: none"
                          href="https://www.behance.net/gallery/126216469/Vaccination-Management-System-C19"
                          target="blank"
                          >Web Design</a
                        ></span
                      >
                      / <span class="w-date">Year 3 Semester 1</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="work-box">
              <a
                href="11.png"
                data-gallery="portfolioGallery"
                class="portfolio-lightbox"
              >
                <div class="work-img">
                  <img src="11.png" alt="" class="img-fluid" />
                </div>
              </a>
              <div class="work-content">
                <div class="row">
                  <div class="col-sm-12">
                    <!-- <h2 class="w-title">Studio Big Bang</h2> -->
                    <div class="tech-box-container">
                      <span class="tech-box">React</span>
                      <span class="tech-box">Express</span>
                      <span class="tech-box">Node.js</span>
                      <span class="tech-box">Firebase</span>
                      <span class="tech-box">Heroku</span>
                    </div>
                    <div class="w-more">
                      <span class="w-ctegory"
                        ><a
                          style="text-decoration: none"
                          href="https://github.com/MadhaviImashi/LMS_frontend"
                          target="blank"
                          >Project Link</a
                        ></span
                      >
                      / <span class="w-date">personal project</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="work-box">
              <a
                href="6.png"
                data-gallery="portfolioGallery"
                class="portfolio-lightbox"
              >
                <div class="work-img">
                  <img src="6.png" alt="" class="img-fluid" />
                </div>
              </a>
              <div class="work-content">
                <div class="row">
                  <div class="col-sm-12">
                    <!-- <h2 class="w-title">Studio Big Bang</h2> -->
                    <div class="tech-box-container">
                      <span class="tech-box">Vue.js</span>
                      <span class="tech-box">CSS</span>
                      <span class="tech-box">Bootstrap</span>
                    </div>
                    <div class="w-more">
                      <span class="w-ctegory"
                        ><a
                          style="text-decoration: none"
                          href="https://imashiuyanahewa.netlify.app"
                          target="blank"
                          >Web Design</a
                        ></span
                      >
                      / <span class="w-date">personal project</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End Portfolio Section -->

    <!-- ======= Blog Section ======= -->
    <section id="blog" class="blog-section-container blog-mf sect-pt4 route">
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <div class="title-box text-center">
              <h3 class="title-a">✍️ CHECKOUT MY LATEST BLOG POSTS</h3>
              <div class="line-mf"></div>
            </div>
            <!-- Blog filter controls -->
            <div class="blog-filter">
              <button
                :class="['filter-btn', blogFilter === 'All' && 'active']"
                @click="filterBlog('All')"
              >
                All
              </button>
              <button
                :class="['filter-btn', blogFilter === 'Tech' && 'active']"
                @click="filterBlog('Tech')"
              >
                Tech
              </button>
              <button
                :class="['filter-btn', blogFilter === 'Life' && 'active']"
                @click="filterBlog('Life')"
              >
                Life
              </button>
            </div>
          </div>
        </div>
        <div class="row blog-grid">
          <!-- Loop through the filteredBlogs computed property -->
          <div
            class="col-md-4 col-lg-3"
            v-for="blog in filteredBlogs"
            :key="blog.id"
          >
            <div class="card card-blog">
              <div class="card-img">
                <a :href="blog.link" target="blank"
                  ><img
                    :src="blog.imgSrc"
                    :alt="blog.title"
                    class="blog-img-fluid"
                /></a>
              </div>
              <div class="card-body blog-card-title">
                <div class="card-category-box">
                  <div :class="['card-category', 'subtle-pill']">
                    <h6 class="category">{{ blog.category }}</h6>
                  </div>
                </div>
                <h3 class="card-title">
                  <a
                    class="blog-card-title-text"
                    :href="blog.link"
                    target="blank"
                    >{{ blog.title }}</a
                  >
                </h3>
                <p class="card-description">
                  {{ blog.description }}
                </p>
              </div>
              <div class="card-footer">
                <div class="post-author">
                  <a href="https://madhaviuyanahewa.medium.com/">
                    <img
                      src="mee.jpeg"
                      alt="author avatar"
                      class="avatar rounded-circle"
                    />
                    <span class="author">{{ blog.author }}</span>
                  </a>
                </div>
                <div class="post-date">
                  <span class="bi bi-clock"></span> {{ blog.time }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End Blog Section -->

    <!-- Lightbox Modal -->
    <div
      v-if="isLightboxOpen"
      class="lightbox-overlay"
      role="dialog"
      aria-modal="true"
      @click="closeLightbox"
    >
      <button
        class="lightbox-close"
        aria-label="Close"
        @click.stop="closeLightbox"
      >
        ×
      </button>
      <div class="lightbox-content" @click.stop>
        <img
          :src="lightboxSrc"
          alt="Portfolio preview"
          @click="closeLightbox"
        />
      </div>
    </div>

    <section id="contact">
      <!-- <h3>Connect with me</h3> -->
      <div class="contact-list2">
        <ul>
          <!-- <li><span class="contact-me-txt">CONTACT ME VIA  ~ </span></li> -->
          <li>
            <a
              href="https://www.linkedin.com/in/madhaviuyanahewa/"
              target="_blank"
              ><i class="fab fa-linkedin"></i
            ></a>
          </li>
          <li>
            <a href="https://www.facebook.com/imashi.uh/" target=" _blank"
              ><i class="fab fa-facebook"></i
            ></a>
          </li>
          <li>
            <a href="https://github.com/MadhaviImashi" target=" _blank"
              ><i class="fab fa-github"></i
            ></a>
          </li>
          <li>
            <a href="https://medium.com/@madhaviuyanahewa" target=" _blank"
              ><i class="fab fa-medium"></i
            ></a>
          </li>
          <li>
            <a href="https://www.behance.net/madhaviuyanahe" target=" _blank"
              ><i class="fab fa-behance"></i
            ></a>
          </li>
        </ul>
      </div>
      <!-- loading spinner -->
      <div class="page-loader" v-if="!isloaded">
        <div class="cube cube1">M</div>
        <div class="cube cube2">I</div>
        <div class="cube cube3">R</div>
        <div class="cube cube4">U</div>
      </div>
    </section>
  </div>
</template>

<script>
import NavBar from "../components/NavBar.vue";

export default {
  name: "Home",
  components: {
    NavBar,
  },
  mounted() {
    setTimeout(() => {
      this.isloaded = true;
    }, 200);

    // Intercept portfolio lightbox links
    this.bindPortfolioLightbox();
    // Global capture to block any residual anchor clicks
    this._captureHandler = (e) => {
      const el = e.target.closest && e.target.closest("a.portfolio-lightbox");
      if (el) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    };
    window.addEventListener("click", this._captureHandler, true);
    // ESC to close
    window.addEventListener("keydown", this.onKeydown);
  },
  beforeDestroy() {
    this.unbindPortfolioLightbox();
    if (this._captureHandler)
      window.removeEventListener("click", this._captureHandler, true);
    window.removeEventListener("keydown", this.onKeydown);
  },
  updated() {
    // Rebind in case DOM changed
    this.unbindPortfolioLightbox();
    this.bindPortfolioLightbox();
  },
  data: () => ({
    isloaded: false,
    panelOpen1: false,
    panelOpen2: false,
    panelOpen3: false,
    panelOpen4: false,
    panelOpen5: false,
    isLightboxOpen: false,
    lightboxSrc: "",
    _lightboxAnchors: [],
    blogFilter: "All",
    blogs: [
      {
        id: 1,
        link: "https://madhaviuyanahewa.medium.com/promises-and-async-await-in-javascript-b57823612250",
        imgSrc:
          "https://miro.medium.com/v2/resize:fit:720/format:webp/1*9CNCGNsQYLXwfl2tmbMI9A.png",
        category: "Tech",
        title: "JavaScript Promises and Async/Await, Explained Simply",
        description:
          "Dive deep into Promises and async/await, learning how to handle sequential and parallel tasks to write cleaner, more readable JS code",
        author: "Imashi Uyanahewa",
        time: "9 min",
      },
      {
        id: 2,
        imgSrc:
          "https://miro.medium.com/v2/resize:fit:720/format:webp/1*xbWeQcg5M5oK9F-avE4JEw.jpeg",
        link: "https://medium.com/tales-from-nimilandia/deep-linking-in-ios-react-native-apps-7e88f8343447",
        category: "Tech",
        title: "Deep Linking in iOS React Native Apps 🔗",
        description:
          "A guide to implementing deep linking for React Native applications on iOS.",
        author: "Imashi Uyanahewa",
        time: "10 min",
      },
      {
        id: 3,
        link: "https://madhaviuyanahewa.medium.com/no-matter-what-life-throws-at-you-4c3a18de3dc6",
        imgSrc:
          "https://miro.medium.com/v2/resize:fit:720/format:webp/0*KrO23IFmZZNnDOFI",
        category: "Life",
        title:
          "No matter what life throws at you. how you respond and what you make out of it is all up to you.",
        description: "Mindset, resilience, and finding perspective.",
        author: "Imashi Uyanahewa",
        time: "7 min",
      },
      {
        id: 4,
        link: "https://madhaviuyanahewa.medium.com/set-up-the-mindset-to-study-effectively-3fc3fe814095",
        imgSrc:
          "https://miro.medium.com/v2/resize:fit:720/format:webp/0*vc_GNwLb3l3MO6Sh",
        category: "Life",
        title: "Set your mindset to study effectively",
        description: "Practical routines to boost daily productivity.",
        author: "Imashi Uyanahewa",
        time: "6 min",
      },
      {
        id: 5,
        link: "https://madhaviuyanahewa.medium.com/what-happened-when-i-started-observing-my-thoughts-4dd7e7161c8a",
        imgSrc:
          "https://miro.medium.com/v2/resize:fit:720/format:webp/0*K9pa9lZ_aXqnzzBM",
        category: "Life",
        title: "What happened when I observed my thoughts",
        description: "Mindfulness notes from personal practice.",
        author: "Imashi Uyanahewa",
        time: "6 min",
      },
      {
        id: 6,
        link: "https://madhaviuyanahewa.medium.com/javascript-asynchronous-programming-5aad2041e50",
        imgSrc: "https://miro.medium.com/max/1400/1*YtYfgsFjc9K6U1-hpUYv8A.png",
        category: "Tech",
        title: "Javascript Asynchronous Programming",
        description:
          "A practical introduction to callbacks, promises, and async/await.",
        author: "Imashi Uyanahewa",
        time: "5 min",
      },
      {
        id: 7,
        link: "https://madhaviuyanahewa.medium.com/what-is-a-rest-api-340e40c4e760",
        imgSrc: "https://miro.medium.com/max/1300/1*Zc8f4cvCQk05jsSqm13jYw.png",
        category: "Tech",
        title: "What is a REST API?",
        description: "Core concepts of REST and how APIs are structured.",
        author: "Imashi Uyanahewa",
        time: "6 min",
      },
      {
        id: 8,
        link: "https://madhaviuyanahewa.medium.com/a-guide-on-how-to-generate-a-pdf-file-in-your-laravel-8-application-82d6225c8c7f",
        imgSrc: "https://miro.medium.com/max/700/1*WEChqyGkX0tujd-de2tg6A.png",
        category: "Tech",
        title: "Generate a PDF in your Laravel 8 app",
        description: "Step-by-step guide to creating PDFs in Laravel.",
        author: "Imashi Uyanahewa",
        time: "4 min",
      },
      {
        id: 9,
        link: "https://madhaviuyanahewa.medium.com/getting-started-with-mongodb-bb844aa8fb6f",
        imgSrc: "https://miro.medium.com/max/650/1*qp2eL9tH7Hy0_pcB4IWk4Q.png",
        category: "Tech",
        title: "Getting started with MongoDB",
        description: "Beginner-friendly overview and setup for MongoDB.",
        author: "Imashi Uyanahewa",
        time: "6 min",
      },
      {
        id: 10,
        link: "https://madhaviuyanahewa.medium.com/introduction-to-koa-js-6e0b483a2bf3",
        imgSrc: "https://miro.medium.com/max/650/1*bGouMpCfFdp6W1SBj6DMCg.png",
        category: "Tech",
        title: "Introduction to Koa JS",
        description:
          "A quick overview of Koa.js and how it compares to Express.",
        author: "Imashi Uyanahewa",
        time: "3 min",
      },
      {
        id: 11,
        link: "https://madhaviuyanahewa.medium.com/what-are-nosql-databases-and-when-to-use-them-c1b43f3c2fb4",
        imgSrc: "https://miro.medium.com/max/650/1*RjheBOMaULRIMw5hTWXR7w.png",
        category: "Tech",
        title: "What are NoSQL databases and when to use them?",
        description: "Key NoSQL types and when they fit best.",
        author: "Imashi Uyanahewa",
        time: "3 min",
      },
      {
        id: 12,
        link: "https://madhaviuyanahewa.medium.com/ever-wonder-what-the-difference-between-the-main-branch-and-the-master-branch-of-git-cb9a2bbab8bf",
        imgSrc:
          "https://miro.medium.com/v2/resize:fit:1000/format:webp/1*fxGcteIDaqq-0YilsX5VlA.png",
        category: "Tech",
        title: "Main vs Master branch in GitHub",
        description: "Explaining the difference and the shift to main.",
        author: "Imashi Uyanahewa",
        time: "6 min",
      },
      {
        id: 13,
        link: "https://medium.com/illumination/how-a-simple-realization-saved-me-from-burnout-54603b1069c9",
        imgSrc:
          "https://miro.medium.com/v2/resize:fit:720/format:webp/0*dGm5kTEWGnb2FpXl", 
        category: "Life",
        title: "How a Simple Realization Saved Me from Burnout",
        description:
          "Finding Peace in the Chaos of Work",
        author: "Imashi Uyanahewa",
        time: "4 min",
      },
    ],
  }),
  computed: {
    filteredBlogs() {
      if (this.blogFilter === "All") {
        return this.blogs;
      }
      return this.blogs.filter((blog) => blog.category === this.blogFilter);
    },
    componentClasses1: function () {
      return {
        panel: true,
        open: this.panelOpen1,
        "open-active": this.panelOpen1,
      };
    },
    componentClasses2: function () {
      return {
        panel: true,
        open: this.panelOpen2,
        "open-active": this.panelOpen2,
      };
    },
    componentClasses3: function () {
      return {
        panel: true,
        open: this.panelOpen3,
        "open-active": this.panelOpen3,
      };
    },
    componentClasses4: function () {
      return {
        panel: true,
        open: this.panelOpen4,
        "open-active": this.panelOpen4,
      };
    },
    componentClasses5: function () {
      return {
        panel: true,
        open: this.panelOpen5,
        "open-active": this.panelOpen5,
      };
    },
  },
  methods: {
    showCV() {
      this.$router.push("/cv");
    },
    bindPortfolioLightbox() {
      const anchors = Array.from(
        document.querySelectorAll("a.portfolio-lightbox")
      );
      anchors.forEach((a) => {
        a.setAttribute("tabindex", "-1");
        a.setAttribute("aria-disabled", "true");
        a.removeAttribute("href");
        a.removeAttribute("data-lightbox-src");
        a.style.pointerEvents = "none";
        a.style.cursor = "default";
      });
    },
    unbindPortfolioLightbox() {
      this._lightboxAnchors.forEach(({ a, handler }) =>
        a.removeEventListener("click", handler)
      );
      this._lightboxAnchors = [];
    },
    openLightbox(src) {
      this.lightboxSrc = src;
      this.isLightboxOpen = true;
      try {
        document.body.style.overflow = "hidden";
      } catch (e) {
        console.warn("Failed to lock body scroll", e);
      }
    },
    closeLightbox() {
      this.isLightboxOpen = false;
      this.lightboxSrc = "";
      try {
        document.body.style.overflow = "";
      } catch (e) {
        console.warn("Failed to unlock body scroll", e);
      }
    },
    onKeydown(e) {
      if (e.key === "Escape" && this.isLightboxOpen) {
        this.closeLightbox();
      }
    },
    openPanel1() {
      this.panelOpen1 = !this.panelOpen1;
    },
    openPanel2() {
      this.panelOpen2 = !this.panelOpen2;
    },
    openPanel3() {
      this.panelOpen3 = !this.panelOpen3;
    },
    openPanel4() {
      this.panelOpen4 = !this.panelOpen4;
    },
    openPanel5() {
      this.panelOpen5 = !this.panelOpen5;
    },
    filterBlog(category) {
      this.blogFilter = category;
    },
  },
};
</script>

<style scoped>
html {
  box-sizing: border-box;
  background: #0b0b0b;
  font-size: 20px;
  font-weight: 200;
}

body {
  margin: 0;
}
/* styles of Intro section */
#intro {
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.9) 0%,
    rgba(11, 11, 11, 1) 100%
  );
  padding-top: 180px;
  width: 100%;
  height: 540px;
  border-bottom: 5px solid #80817c;
}
.profile-img-wrap {
  text-align: center;
  padding-bottom: 32px;
}
.profile-img {
  width: 176px;
  height: 176px;
  border-radius: 50%;
}
/* styles of Technologies section */
#learnings {
  background-color: #000;
  padding-top: 20px;
  width: 100%;
  color: white;
}
/* styles of Blogs section */
#blogs {
  background-color: #111111;
  padding-top: 20px;
  width: 100%;
  color: white;
}
.hand-icon {
  font-size: 20px;
}
.blogs-section-wrap {
  padding: 70px 30px 30px 30px;
}
.blog-section-title {
  /* text-align: center; */
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 20px;
  color: #80817c;
}
.blog {
  display: flex; /*this will display the 2 sections in this class next to each other*/
  flex-wrap: wrap; /* then it will go to the next line, when it doesn't have space*/
  max-width: 800px;
  margin: 20px 10px; /* this will make them align to center*/
  justify-content: center; /*videos came to the center after this*/
  background-color: black;
  padding: 20px;
  flex-direction: column;
  align-items: center;
  box-shadow: rgb(255 255 255 / 11%) 0px 48px 100px 0px;
}
.blog-img {
  border-radius: 2%;
}
.blog-caption {
  font-size: 12px;
  font-weight: 400;
}
.social-ul a {
  font-size: 30px;
  padding: 40px;
}

#connect {
  background-color: black;
}

*,
*:before,
*:after {
  box-sizing: inherit;
}
/* styles of panels in Quotes section */
.panels {
  overflow: hidden;
  height: 640px;
  display: flex;
}

@media screen and (max-width: 600px) {
  #panel1 {
    display: none;
  }
  #panel2 {
    display: none;
  }
  #panel4 {
    display: none;
  }
  #panel5 {
    display: none;
  }
  #panel3Quote {
    display: none;
  }
  .panels {
    height: 460px;
  }
}

.panel {
  backface-visibility: purple;
  color: #e6e6e6;
  text-align: center;
  align-items: center;
  transition: font-size 0.7s cubic-bezier(0.02, 0.57, 1, 0.43),
    flex 0.7s cubic-bezier(0.02, 0.57, 1, 0.43), background 0.2s;
  font-size: 20px;
  background-size: cover;
  background-position: center;
  flex: 1;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  cursor: nesw-resize;
}
#panel1 {
  background-image: url("../../public/imgLeft.png");
}
#panel2 {
  background-image: url("../../public/imgRepeated.jpg");
}
#panel3 {
  background-image: url("../../public/imgMIddle.png");
}
#panel4 {
  background-image: url("../../public/imgRepeated.jpg");
}
#panel5 {
  background-image: url("../../public/imgRight.png");
}

/*flex items*/
.panel > * {
  margin: 0;
  width: 100%;
  transition: transform 0.5s;
  flex: 1 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
.panel > *:first-child {
  transform: translateY(-100%);
}
.panel.open-active > *:first-child {
  transform: translateY(0);
}
.panel > *:last-child {
  transform: translateY(100%);
}
.panel.open-active > *:last-child {
  transform: translateY(0);
}

.panel p {
  text-transform: uppercase;
  font-size: 40px;
  font-weight: 600;
}
.panel p:nth-child(2) {
  font-size: 28px;
  font-weight: 500;
  color: white;
}
.panel.open {
  flex: 5;
  font-size: 2em;
  color: #8e8f8c;
  cursor: pointer;
}
.panel.open p:nth-child(2) {
  font-size: 28px;
  font-weight: 500;
  color: white;
}
/* styles of dynamic text in the Intro section */
.hello-txt {
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 500;
  font-size: 15px;
}
.dynamic-txt-box {
  display: flex;
  align-items: center;
  justify-content: center;
  background: black;
}
.wrapper {
  display: flex;
  margin-left: 20px;
}
.wrapper .static-txt {
  color: #fff;
  font-size: 28px;
  font-weight: 400;
}
.wrapper .dynamic-txts {
  height: 90px;
  line-height: 90px;
  overflow: hidden;
}
.dynamic-txts li {
  list-style: none;
  color: #80817c;
  font-size: 30px;
  font-weight: 600;
  position: relative;
  top: 0;
  animation: slide 16s steps(4) infinite;
}
@keyframes slide {
  100% {
    top: -360px;
  }
}
.dynamic-txts li span {
  position: relative;
  margin: 5px 0;
  line-height: 90px;
}
.dynamic-txts li span::after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  background: black;
  border-left: 2px solid #80817c;
  animation: typing 4s steps(10) infinite;
}
@keyframes typing {
  40%,
  60% {
    left: calc(100% + 30px);
  }
  100% {
    left: 0;
  }
}
/* styles of Technologies section */
.technology-section-wrap {
  padding: 80px 120px;
}
.tech-description {
  padding: 10px 20px 10px 10px;
  border-bottom: 0.5px solid #1f1f1f;
}
.tech-desc-title {
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 15px;
}
.tech-icon-card-wrap {
  background-color: #111;
}
.tech-icon-card {
  background-color: #1a1a1a;
}
.tech-icons-row {
  margin-bottom: 40px;
}

/* styles of footer section */
#contact {
  background: black;
  align-content: center;
  justify-content: center;
  color: white;
  background-color: black;
  border-top: 1px solid #1f1f1f;
}
.contact-list {
  display: flex;
}
.contact-list2 {
  display: flex;
  align-items: center;
  justify-content: center;
}
.contact-list ul,
.contact-list2 ul {
  display: flex;
  margin: 0; /*this will remove the empty spaces/margins coming around */
  padding: 0;
  margin-bottom: 20px;
  padding-bottom: 20px;
  margin-top: 20px;
  justify-content: center;
  list-style-type: none;
  font-size: 20px;
}
.contact-list ul li a {
  color: #8e8f8c;
  padding: 20px;
  text-decoration: none;
}
.contact-list2 ul li a {
  color: #8e8f8c;
  padding: 20px;
  text-decoration: none;
}
.miru {
  color: black;
  background-color: #80817c;
  padding-top: 0px;
  margin-top: 0px;
}
.contact-me-txt {
  font-size: 13px;
  font-weight: 600;
  margin-right: 10px;
  color: #8e8f8c;
}

/* ovewrite some styles ..*/
ul,
p {
  margin-bottom: 0 !important;
}
.card-body {
  background-color: #000;
  padding: 20px;
}

@media only screen and (max-width: 1200px) {
  .technology-section-wrap {
    padding: 15px 25px;
  }
}

@media only screen and (max-width: 1200px) {
  .contact-list ul li a {
    padding: 10px;
  }
}

/* loading animation spinner */
/* $colors: #8CC271, #69BEEB, #F5AA39, #E9643B; */
.page-loader {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: black;
  z-index: 999;
}
.cube {
  width: 40px;
  height: 40px;
  color: black;
  font-weight: 600;
  text-align: center;
  font-size: 20px;
  padding-top: 5px;
  margin-right: 10px;
  border-radius: 50%;
  background-color: #555;
}
.cube1 {
  position: relative;
  animation: moveToLeft 2s infinite;
}
.cube4 {
  position: relative;
  animation: moveToRight 2s infinite;
}

@keyframes moveToRight {
  from {
    left: 0px;
  }
  to {
    left: 10px;
  }
}
@keyframes moveToLeft {
  from {
    right: 0px;
  }
  to {
    right: 10px;
  }
}

/*--------------------------------------------------------------
# Portfolio
--------------------------------------------------------------*/
.work-box {
  margin-bottom: 3rem;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  background-color: #0e0e0e;
  border: 1px solid #1f1f1f;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.work-box:hover img {
  transform: scale(1.08);
}

.work-img {
  display: block;
  overflow: hidden;
}

.work-img img {
  transition: all 0.6s ease;
}

.work-content {
  background: black;
  padding: 1rem 3% 1rem 4%;
}

.work-content .w-more {
  padding-top: 5px;
  color: #a1a1a1;
  font-size: 0.8rem;
}

.w-date {
  color: darkgray;
}

.work-content .w-more .w-ctegory {
  color: #bdbdbd;
}

.work-content .w-like {
  font-size: 2rem;
  color: #bdbdbd;
  float: right;
}

.work-content .w-like a {
  color: #bdbdbd;
}

.work-content .w-like .num-like {
  font-size: 0.7rem;
}

.w-title {
  font-size: 1.2rem;
}

/*--------------------------------------------------------------
# Portfolio Details
--------------------------------------------------------------*/
.portfolio-details {
  padding-top: 40px;
}

.portfolio-details .portfolio-details-slider img {
  width: 100%;
}

.portfolio-details .portfolio-details-slider .swiper-pagination {
  margin-top: 20px;
  position: relative;
}

.portfolio-details
  .portfolio-details-slider
  .swiper-pagination
  .swiper-pagination-bullet {
  width: 12px;
  height: 12px;
  background-color: #fff;
  opacity: 1;
  border: 1px solid #6b6b6b;
}

.portfolio-details
  .portfolio-details-slider
  .swiper-pagination
  .swiper-pagination-bullet-active {
  background-color: #6b6b6b;
}

.portfolio-details .portfolio-info {
  padding: 30px;
  box-shadow: 0px 0 30px rgba(78, 78, 78, 0.08);
}

.portfolio-details .portfolio-info h3 {
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #eee;
}

.portfolio-details .portfolio-info ul {
  list-style: none;
  padding: 0;
  font-size: 15px;
}

.portfolio-details .portfolio-info ul li + li {
  margin-top: 10px;
}

.portfolio-details .portfolio-description {
  padding-top: 30px;
}

.portfolio-details .portfolio-description h2 {
  font-size: 26px;
  font-weight: 700;
  margin-bottom: 20px;
}

.portfolio-details .portfolio-description p {
  padding: 0;
}

/*--------------------------------------------------------------
# Blog
--------------------------------------------------------------*/
.card-blog {
  margin-bottom: 3rem;
  min-height: 420px;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,
    rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
}

.card-blog .card-body {
  position: relative;
  background: #000;
}

.card-blog .card-category-box {
  position: absolute;
  text-align: center;
  top: -16px;
  left: 15px;
  right: 15px;
  line-height: 25px;
  overflow: hidden;
}

.card-blog .card-category {
  display: inline-block;
  color: black;
  padding: 0 15px 5px;
  overflow: hidden;
  background-color: white;
  border: 1px solid black;
  border-radius: 4px;
}

/* Subtle category pill */
.subtle-pill {
  background: rgba(255, 255, 255, 0.06) !important;
  border: 1px solid #2a2a2a !important;
}
.subtle-pill .category {
  color: #d2d2d2;
}

.card-blog .card-category .category {
  display: inline-block;
  font-size: 0.7rem;
  letter-spacing: 0.1px;
  margin-bottom: 0;
}

.card-blog .card-title {
  font-size: 14px;
  margin-top: 0.6rem;
}

.card-blog .card-description {
  font-size: 12px;
  color: #a1a1a1;
  text-align: justify;
}

.card-blog .post-author {
  display: inline-block;
  font-size: 12px;
}

.card-blog .post-date {
  color: #a1a1a1;
  display: inline-block;
  float: right;
}

.avatar {
  width: 25px;
  height: 25px;
  margin-right: 4px;
  overflow: hidden;
}

.blog-card-title {
  background-color: white;
  text-decoration: none;
}

.blog-section-container {
  background: #000000;
  padding: 30px 120px 50px 120px;
}

.card-footer {
  background-color: #1a1a1a;
  font-size: 12px;
}
.work-section {
  background: #000000;
  background-image: url(../../public/bb.png);
  background-size: contain;
  opacity: 0.9;
}

.work-section-container {
  padding: 30px 120px 50px 120px;
}

.tech-box-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.tech-box {
  padding: 5px 10px;
  margin-right: 5px;
  font-size: 11px;
  color: white;
  border-radius: 10%;
  background: #1f1f1f;
}

/* Fix accidental text artifact */
.tech-box {
  margin-bottom: 5px;
}

.title-a {
  font-size: 14px;
  color: gray;
  font-weight: bold;
  padding-bottom: 20px;
}

.blog-img-fluid {
  width: 100%;
  height: 220px;
}

.blog-card-title-text {
  color: #d4d4d4;
  text-decoration: none;
}

@media (min-width: 1400px) {
  .container-xxl,
  .container-xl,
  .container-lg,
  .container-md,
  .container {
    max-width: 1920px;
  }
}

@media (min-width: 300px) and (max-width: 992px) {
  .contact-list {
    flex-wrap: wrap;
  }
  .contact-list2 {
    flex-wrap: wrap;
  }
  .tech-box-container {
    flex-direction: row;
    flex-wrap: wrap;
  }
  .tech-box {
    margin-bottom: 5px;
  }
  .blog-section-container {
    padding: 20px !important;
  }
  .work-section-container {
    padding: 20px !important;
  }
  .profile-img {
    width: 144px;
    height: 144px;
  }
  #intro {
    padding-top: 140px;
    height: 520px;
  }
}

/* Define the blinking animation */
@keyframes blink {
  0% {
    background-color: transparent; /* Initial background color */
  }
  50% {
    background-color: #6c757d; /* Color to blink */
    color: white;
  }
  100% {
    background-color: transparent; /* Back to the initial background color */
  }
}

/* Apply the animation to the button */
.blinking-button {
  animation: blink 3s infinite;
  margin-bottom: 20px;
}

.oss-section-container {
  background: #000000;
  padding: 30px 120px 10px 120px;
}
.fun-section-container {
  background: #000000;
  padding: 10px 120px 50px 120px;
}
.badges {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
}
.badge {
  background: #1f1f1f;
  color: #cfcfcf;
  padding: 6px 8px;
  border-radius: 6px;
  font-size: 12px;
}
@media (min-width: 300px) and (max-width: 992px) {
  .oss-section-container {
    padding: 20px !important;
  }
  .fun-section-container {
    padding: 20px !important;
  }
}

/* Enhanced cards/chips styling */
.work-box {
  border-radius: 12px;
  overflow: hidden;
  background-color: #0f0f0f;
  border: 1px solid #222;
  transition: transform 0.22s ease, box-shadow 0.22s ease,
    border-color 0.22s ease;
}
.work-box a {
  cursor: default;
}
.work-box:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.45);
  border-color: #6b6b6b;
}
.work-img {
  height: auto;
}
.work-img img {
  width: 100%;
  aspect-ratio: 16/15;
  height: auto;
  object-fit: cover;
}
.work-content {
  padding: 16px 18px 14px 18px;
}
.w-title {
  font-size: 16px;
  font-weight: 600;
}
.work-content .w-more {
  font-size: 13px;
  color: #a9a9a9;
}
.work-content .w-like {
  font-size: 1.6rem;
}

.card-blog {
  border-radius: 12px;
  overflow: hidden;
  background-color: #0f0f0f;
  border: 1px solid #222;
  transition: transform 0.22s ease, box-shadow 0.22s ease,
    border-color 0.22s ease;
}
.card-blog:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.45);
  border-color: #6b6b6b;
}
.card-blog .card-body {
  padding: 16px 18px;
}
.card-blog .card-title {
  font-size: 16px;
  font-weight: 600;
}
.card-blog .card-description {
  font-size: 13px;
  line-height: 1.6;
}
.card-footer {
  background-color: #121212;
}

.blog-img-fluid {
  width: 100%;
  aspect-ratio: 16/9;
  object-fit: cover;
}

.tech-box {
  background: #1a1a1a;
  border: 1px solid #222;
  border-radius: 12px;
  padding: 6px 10px;
  font-size: 12px;
  color: #e0e0e0;
}

/* Focus visibility for keyboard users */
.work-box:focus-visible,
.card-blog:focus-visible,
.nav-btn:focus-visible,
a:focus-visible {
  outline: 2px solid #9aa0a6;
  outline-offset: 2px;
}

/* Reduce motion for users who prefer it */
@media (prefers-reduced-motion: reduce) {
  .work-box,
  .card-blog,
  .work-img img,
  .work-box:hover,
  .card-blog:hover {
    transition: none !important;
  }
}

/* Lightbox styles */
.lightbox-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3000;
  cursor: zoom-out;
}
.lightbox-content {
  position: relative;
  max-width: 92vw;
  max-height: 92vh;
}
.lightbox-content img {
  max-width: 100%;
  max-height: 100%;
  border-radius: 8px;
  cursor: zoom-out;
}
.lightbox-close {
  position: fixed;
  top: 16px;
  right: 16px;
  background: rgba(31, 31, 31, 0.9);
  color: #fff;
  border: 1px solid #6b6b6b;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  line-height: 38px;
  text-align: center;
  font-size: 22px;
  cursor: pointer;
  z-index: 3050;
}
.lightbox-close:hover {
  background: rgba(42, 42, 42, 0.95);
}

/* Hard-disable portfolio anchor interactions */
a.portfolio-lightbox {
  pointer-events: none !important;
  cursor: default !important;
}

/* Responsive tweaks for blog images */
.blog-img-fluid {
  height: clamp(160px, 22vw, 260px);
}
@media (max-width: 600px) {
  .blog-img-fluid {
    height: clamp(150px, 40vw, 220px);
    aspect-ratio: auto;
  }
}

/* Consistent blog image presentation */
.card-img {
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(180deg, #0f0f0f 0%, #121212 100%);
  border-bottom: 1px solid #222;
  padding: 10px;
  height: clamp(180px, 24vw, 280px);
}
.card-img .blog-img-fluid {
  width: auto;
  max-width: 100%;
  max-height: calc(100% - 12px);
  height: auto;
  object-fit: contain; /* keep original aspect */
  background: transparent; /* ensure image background isn't fighting */
  border-radius: 6px;
  transition: transform 0.22s ease, opacity 0.22s ease;
}
.card-img:hover .blog-img-fluid {
  opacity: 0.95;
  transform: scale(1.01);
}

/* Blog filter styles */
.blog-filter {
  display: flex;
  gap: 8px;
  justify-content: center;
  margin: 8px 0 20px;
}
.filter-btn {
  background: #121212;
  color: #dcdcdc;
  border: 1px solid #2a2a2a;
  border-radius: 8px;
  padding: 6px 12px;
  cursor: pointer;
}
.filter-btn:hover {
  background: #1a1a1a;
}
.filter-btn.active {
  background: #1f1f1f;
  border-color: #6b6b6b;
}
.hidden {
  display: none !important;
}
</style>
